var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOutOfStock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#FFE2E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33399 16.6666C8.78853 16.6666 8.26744 16.4465 7.22527 16.0063C4.63108 14.9104 3.33398 14.3625 3.33398 13.4408C3.33398 13.1828 3.33398 8.70964 3.33398 6.66663M9.33399 16.6666L9.33398 9.56985M9.33399 16.6666C9.74514 16.6666 10.0807 16.5416 10.6673 16.2914M15.334 6.66663V9.99996",
    stroke: "#EE0033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.666 12L14.666 14M14.666 14L16.666 16M14.666 14L12.666 16M14.666 14L16.666 12",
    stroke: "#EE0033",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8846 8.46096L4.93713 7.5186C3.86837 7.00144 3.33398 6.74286 3.33398 6.33337C3.33398 5.92389 3.86837 5.66531 4.93713 5.14814L6.8846 4.20579C8.08654 3.62418 8.68751 3.33337 9.33398 3.33337C9.98046 3.33337 10.5814 3.62418 11.7834 4.20578L13.7308 5.14814C14.7996 5.66531 15.334 5.92389 15.334 6.33337C15.334 6.74286 14.7996 7.00144 13.7308 7.5186L11.7834 8.46096C10.5814 9.04257 9.98046 9.33337 9.33398 9.33337C8.68751 9.33337 8.08654 9.04257 6.8846 8.46096Z",
    stroke: "#EE0033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 10L6.66732 10.6667",
    stroke: "#EE0033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 4.66663L6 7.99996",
    stroke: "#EE0033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOutOfStock);
export default __webpack_public_path__ + "static/media/icon-out-of-stock.e167f6d256697eaf096c75acf5f1bf8f.svg";
export { ForwardRef as ReactComponent };